import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Classes from '../Classes';
import FavouriteIcon from './FavouriteIcon';
import MediaQuery from 'react-responsive';
import {PackageName} from '../Constants';

const FavouriteIconComponent = ({
  dtmTag, id, handleClick, isFavourited, iconName, altSVG, label, packageName, exhibitorId, isPrioritySlotPremiumExhibitor, isVariantC
}) => {
  const getProductDtmTag = ()=> {
    const isPremiumExhibitorProduct = packageName.toUpperCase() === PackageName.GOLD || packageName.toUpperCase() === PackageName.SILVER;
    let dtmTag =  { productId: id, exhibitorId: exhibitorId, package: packageName }
    if(isVariantC){
      dtmTag.priorityTagEnabledForCTesting = isPremiumExhibitorProduct;
    }
    return dtmTag;
  }

  const onKeyDownHandler = (e) => {
    const keyDown = e.key !== undefined ? e.key : e.keyCode;
    if ((keyDown === 'Enter' || keyDown === 13) || (['Spacebar', ' '].indexOf(keyDown) >= 0 || keyDown === 32)) {
      e.preventDefault();
      handleClick();
    }
  }

  const attribute = (id.substring(0, 3) === 'pro' ? getProductDtmTag()
    : { exhibitorId: id, package: packageName });
      const dtmTagToDisplay = (packageName !==undefined && packageName !== null) ? `${dtmTag}_${packageName}${isPrioritySlotPremiumExhibitor}`: `${dtmTag}${isPrioritySlotPremiumExhibitor}`;

  return (
    <div
      data-testid="favourite-icon-component"
      data-dtm={dtmTagToDisplay}
      data-dtm-attributes={JSON.stringify(attribute)}
      className={classnames(Classes.exhibitorDetailsInfo, Classes.primaryButton)}
      onClick={handleClick}
      onKeyDown={onKeyDownHandler}
      role="button"
      tabIndex={0}
    >
      <span className={Classes.exhibitorFavoriteIcons}>
        <FavouriteIcon
          isFavourited={isFavourited}
          iconName={iconName}
          altSVG={altSVG}
        />
      </span>
        <MediaQuery minWidth={768}>
          <span className={Classes.singleLineEllipsis}>{label}</span>
        </MediaQuery>
    </div>
  );
};

FavouriteIconComponent.propTypes = {
  dtmTag: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  packageName: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  isFavourited: PropTypes.bool.isRequired,
  iconName: PropTypes.string.isRequired,
  altSVG: PropTypes.string.isRequired,
  isPrioritySlotPremiumExhibitor:  PropTypes.string,
};

export default FavouriteIconComponent;
